// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2r5dv","name":"styles_name__ybgko","phone":"styles_phone__1kWKu"};